import httpClient from '../httpClient';

export async function getGlossario(id: string) {
  try {
    const response = await httpClient.get(`/api/glossario/${id}`);
    return response.data;
  } catch (error) {
    throw new Error('Erro ao obter registro: ' + error);
  }
}

export async function getAllGlossario() {
  try {
    const response = await httpClient.get(`/api/glossario`);
    return Array.isArray(response.data.registros)
      ? response.data.registros
      : [];
  } catch (error) {
    throw new Error('Erro ao obter lista de registros: ' + error);
  }
}
